module.exports = __webpack_public_path__ + "img/store.d2580f18.png";